const REQUIRED_FIELD_MESSAGE = 'This is a required field';
const NO_MATCHING_START_MESSAGE = 'There is no matching start time with this end time';
const NO_MATCHING_END_MESSAGE = 'There is no matching end time with this start time';
const INVALID_SEGMENT_LENGTH = 'Segments must be at least 1 minute long';
const SEGMENTS_RANGE_ERROR_MESSAGE = "Segments must not exceed the shift's scheduled time.";
const DUPLICATED_SEGMENTS_MESSAGE = 'Duplicate segments cannot be added.';
export const INVALID_TIME_MESSAGE = 'Enter a valid time';

export const defaultSegments = (shiftStart, shiftEnd) => [
	{ start: shiftStart.clone(), end: null, unitId: null },
	{ start: null, end: shiftEnd.clone(), unitId: null }
];

export const sortSegments = (segments) =>
	[...segments].sort((a, b) => {
		if (!a.start || !b.start) {
			return 0;
		}
		return a.start.valueOf() - b.start.valueOf();
	});

export const canDeleteSegment = (index, total) => {
	if (index === 0) {
		return false;
	}
	if (total <= 2) {
		return false;
	}
	return true;
};

export const validateSegments = (segments, shiftStart, shiftEnd) => {
	const errors = {};
	const sorted = sortSegments(segments.map((segment, originalIndex) => ({ ...segment, originalIndex })));

	sorted.forEach((segment) => {
		if (!segment.start || !segment.start.isValid()) {
			errors[`segments[${segment.originalIndex}].startTime`] = REQUIRED_FIELD_MESSAGE;
		}
		if (!segment.end || !segment.end.isValid()) {
			errors[`segments[${segment.originalIndex}].endTime`] = REQUIRED_FIELD_MESSAGE;
		}
	});

	if (Object.keys(errors).length > 0) {
		return { isValid: false, errors, rangeError: null };
	}

	const startValues = sorted.map((segment) => segment.start.valueOf());
	const endValues = sorted.map((segment) => segment.end.valueOf());

	sorted.forEach((segment) => {
		const startValue = segment.start.valueOf();
		const endValue = segment.end.valueOf();
		const isFirst = segment.originalIndex === 0;
		const isLast = segment.originalIndex === sorted.length - 1;
		if (!isFirst && !endValues.includes(startValue)) {
			errors[`segments[${segment.originalIndex}].startTime`] = NO_MATCHING_END_MESSAGE;
		}
		if (!isLast && !startValues.includes(endValue)) {
			errors[`segments[${segment.originalIndex}].endTime`] = NO_MATCHING_START_MESSAGE;
		}

		if (!isFirst && segment.start.isSame(segment.end)) {
			errors[`segments[${segment.originalIndex}].startTime`] = INVALID_SEGMENT_LENGTH;
		}
		if (!isLast && segment.start.isSame(segment.end)) {
			errors[`segments[${segment.originalIndex}].endTime`] = INVALID_SEGMENT_LENGTH;
		}
	});

	let rangeError = null;
	if (Object.keys(errors).length === 0) {
		const exceedsShiftEnd = sorted.some(
			(segment) => segment.end.isAfter(shiftEnd) || segment.start.isAfter(segment.end)
		);

		if (exceedsShiftEnd) {
			rangeError = SEGMENTS_RANGE_ERROR_MESSAGE;
		}
		const hasDuplicates =
			new Set(sorted.map((segment) => `${segment.start.valueOf()}-${segment.end.valueOf()}`)).size < sorted.length;

		if (hasDuplicates) {
			rangeError = DUPLICATED_SEGMENTS_MESSAGE;
		}
	}

	return { isValid: Object.keys(errors).length === 0 && !rangeError, errors, rangeError };
};

export const toPayload = (segments) =>
	segments.map((segment) => ({
		startTime: segment.start ? segment.start.format('HH:mm') : null,
		endTime: segment.end ? segment.end.format('HH:mm') : null,
		unitId: segment.unitId || null
	}));

export const formatRange = (segment) => {
	const start = segment.start ? segment.start.format('h:mm A [(]ddd[)]') : '';
	const end = segment.end ? segment.end.format('h:mm A [(]ddd[)]') : '';
	return `${start} – ${end}`;
};
